<template>
  <layout-content>
    <template #toolbar>
      <span style="font-size:1em;color:#606266">选择年份:</span>
      <el-select
        v-model="queryData.years"
        size="small"
        multiple
        collapse-tags
        placeholder="请选择"
        style="width: 160px;"
      >
        <el-option
          v-for="item in earliest"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <span style="font-size:1em;color:#606266;margin-left: 5px;">选择月份:</span>
      <el-select
        v-model="queryData.fromMonth"
        size="small"
        placeholder="请选择"
        style="width: 80px;"
      >
        <el-option
          v-for="item in monthList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <span style="font-size:.7em;color:#606266"> ～ </span>
      <el-select
        v-model="queryData.toMonth"
        size="small"
        placeholder="请选择"
        style="width: 80px;"
      >
        <el-option
          v-for="item in monthList"
          :key="item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>

      <completed-query v-model="queryData.isAuditCompleted" :is-show-fuse="false" @change="onAuditCompletedChanged" />

      <el-button
        :disabled="queryData.years.length < 2"
        type="orange"
        size="small"
        @click="getData"
      >查询</el-button>

      <!-- <el-radio-group v-model="queryData.type" size="small">
        <el-radio-button label="bar">实况</el-radio-button>
        <el-radio-button label="line">标况</el-radio-button>
      </el-radio-group> -->
    </template>

    <template #body>
      <sidebar-content title="选择站点">
        <template #sidebar-body>
          <el-tree
            :data="treeData"
            :props="defaultProps"
            ref="tree"
            accordion
            @node-click="handleNodeClick"
          ></el-tree>
        </template>

        <template #sidebar-content-body>
          <div style="height:100%;overflow-y:scroll;padding:0 20px;">
            <div style="width: 100%;display: flex;justify-content: space-between;">
              <div class="chart-item-body" style="width: 32%;">
                <h4>{{currentArea}}-AQI优良天数</h4>
                <a-q-i-excellent-days-chart
                  ref="days-chart"
                  :data="daysChart"
                />
              </div>
              <div class="chart-item-body" style="width: 32%;">
                <h4>{{queryData.years[0]}}年优良率</h4>
                <a-q-i-excellent-rate-chart
                  ref="rate-chart"
                  :data="rateChart"
                />
              </div>
              <div class="chart-item-body" style="width: 32%;">
                <h4>{{queryData.years[0]}}年较{{queryData.years[1]}}年常规六项均值变化</h4>
                <a-q-i-excellent-avg-chart
                  ref="data-renders"
                  :data="AQIExcellentAvgChartData"
                />
              </div>
            </div>
            <div class="chart-item-body">
              <h4>{{currentArea}}-AQI等级天数</h4>
              <a-q-i-level-days-chart
                ref="aqi-days-chart"
                :data="AQIDaysChart"
              />
            </div>
            <div class="chart-item-body" style="height: 430px;padding-bottom: 0;">
              <h4>{{currentArea}}-同比数据</h4>
              <el-table
                :data="tableData"
                :span-method="objectSpanMethod"
                border
                style="width: 100%; margin-top: 10px"
              >
                <el-table-column prop="levelName" label="级别" align="center"></el-table-column>
                <el-table-column label="天数(天)" align="center">
                  <el-table-column v-for="(month, index) in dataDate" :key="index" :prop="`${month}days`" :label="month" align="center"></el-table-column>
                </el-table-column>
                <el-table-column label="优良天数(天)" align="center">
                  <el-table-column v-for="(month, index) in dataDate" :key="index" :prop="`${month}excellent`" :label="month" align="center"></el-table-column>
                </el-table-column>
                <el-table-column label="优良率(%)" align="center">
                  <el-table-column v-for="(month, index) in dataDate" :key="index" :prop="`${month}excellentRate`" :label="month" align="center"></el-table-column>
                </el-table-column>
              </el-table>
            </div>
          </div>
        </template>
      </sidebar-content>
    </template>
  </layout-content>
</template>

<script>
import BaseFactorData from '../../../BaseFactorData'
import AQIExcellentAvgChart from '../../../../components/Data/AQIExcellentAvgChart'
import AQIExcellentDaysChart from '../../../../components/Data/AQIExcellentDaysChart'
import AQIExcellentRateChart from '../../../../components/Data/AQIExcellentRateChart'
import AQILevelDaysChart from '../../../../components/Data/AQILevelDaysChart'
import DeviceCategoryConfig from '../../../../model/DeviceCategoryConfig'

export default {
  name: 'StatisticalAnalysisAQIYOY',
  routeInfo: {
    label: '同比分析'
  },
  extends: BaseFactorData,
  data () {
    return {
      endDatePickerOptions: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e7
        }
      },
      queryData: {
        isAuditCompleted: false, // finished
        type: 'site',
        fromMonth: 1,
        toMonth: 12,
        years: [Number(new Date().format('YYYY')), (new Date().format('YYYY') - 1)],
        ids: []
      },
      defaultProps: {
        children: 'children',
        label: 'name'
      },
      currentArea: '',
      dataArray: [{
        date: '2020',
        CO: 0,
        NO2: 15.583579,
        O3: 85.09395,
        'PM2.5': 9.796899,
        PM10: 27.675243,
        SO2: 16.429434,
        classification: [{
          days: 10,
          level: 1
        }, {
          days: 2,
          level: 2
        }, {
          days: 1,
          level: 3
        }, {
          days: 0,
          level: 4
        }, {
          days: 0,
          level: 5
        }, {
          days: 0,
          level: 6
        }]
      }, {
        date: '2021',
        CO: 0,
        NO2: 16.583579,
        O3: 86.09395,
        'PM2.5': 10.796899,
        PM10: 30.675243,
        SO2: 17.429434,
        classification: [{
          days: 15,
          level: 1
        }, {
          days: 3,
          level: 2
        }, {
          days: 1,
          level: 3
        }, {
          days: 0,
          level: 4
        }, {
          days: 0,
          level: 5
        }, {
          days: 0,
          level: 6
        }]
      }],
      daysChart: {},
      rateChart: {},
      AQIExcellentAvgChartData: {
        xAxisData: ['CO', 'NO2', 'O3', 'PM2,5', 'PM10', 'SO2'],
        seriesData: []
      },
      AQIDaysChart: {},
      dataDate: [],
      tableData: []
    }
  },
  components: {AQIExcellentAvgChart, AQIExcellentDaysChart, AQIExcellentRateChart, AQILevelDaysChart},
  computed: {
    siteDeviceCategoryConfig () {
      return [
        new DeviceCategoryConfig(1, true),
        new DeviceCategoryConfig(process.env.SO2_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.NO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.CO_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.O3_DEVICE_CATEGORY, false),
        new DeviceCategoryConfig(process.env.PM_DEVICE_CATEGORY, false)
      ]
    },
    minSiteSelectNumber: () => 1,
    completeAllData: () => false,
    valueProp: () => 'value',
    _siteDeviceCategoryConfig () {
      let bit = 0
      return this.siteDeviceCategoryConfig.reduce((map, deviceCategoryConfig) => {
        let {categoryId} = deviceCategoryConfig
        let num = 1 << bit

        if (!map.map[categoryId]) {
          map.map[categoryId] = {
            bit: bit,
            filter: deviceCategoryConfig.filter
          }
          map.total |= num
          map.min |= num & (-deviceCategoryConfig.required)
          bit++
        }

        return map
      }, {
        map: {},
        total: 0,
        min: 0
      })
    },
    _filterSites () {
      let {profileSiteDevices} = this

      if (profileSiteDevices.length === 0) {
        return []
      }

      let {_siteDeviceCategoryConfig: {map: deviceCategoryMap, total, min}, profileSiteMap} = this

      return Object.values(profileSiteDevices.reduce((map, siteDevice) => {
        let {siteId} = siteDevice
        let site = profileSiteMap[siteId]

        if (!site) {
          return map
        }

        let deviceCategoryConfig = deviceCategoryMap[siteDevice.categoryId]

        if (deviceCategoryConfig) {
          let {filter} = deviceCategoryConfig
          let siteDeviceFactors = filter instanceof Function
            ? filter(siteDevice.siteDeviceFactors)
            : [...siteDevice.siteDeviceFactors]

          if (siteDeviceFactors.length > 0) {
            let {bit} = deviceCategoryConfig
            let tmpSite = map[siteId]

            if (!tmpSite) {
              tmpSite = map[siteId] = {
                id: siteId,
                name: site.name,
                total: 0,
                devices: []
              }
            }

            tmpSite.total |= 1 << bit
            tmpSite.devices.push({
              ...siteDevice,
              siteDeviceFactors
            })
          }
        }

        return map
      }, {})).filter(site => (site.total & total) >= min)
    },
    filterSites () {
      return this._filterSites
    },
    filterSiteMap () {
      return this.filterSites.reduce((map, site) => {
        map[site.id] = site
        return map
      }, {})
    },
    isNoSelectedSites () {
      return this.query.siteIds.length === 0
    },
    canNotSearch () {
      return this.isNoSelectedSites
    },
    earliest () {
      let result = []
      let start = process.env.Y_O_Y_YEAR
      for (let i = start; i <= Number(new Date().format('YYYY')); i++) {
        result.push({
          value: i,
          label: i
        })
      }
      return result.sort((a, b) => b.value - a.value)
    },
    monthList () {
      let result = []
      for (let i = 1; i <= 12; i++) {
        result.push({
          value: i,
          label: i
        })
      }
      return result
    },
    treeData () {
      let {filterSites} = this
      return filterSites.map(el => {
        return {
          ...el
        }
      })
    }
  },
  methods: {
    setSiteIds () {
      let {filterSites} = this

      if (filterSites.length > 0) {
        this.queryData.ids = [filterSites[0].id]
        this.currentArea = filterSites[0].name
        this.setCurrentQuery()
        this.getData()
      }
    },
    yearChange () {
      let {queryData: {years}} = this
      this.queryData.years = years.sort((a, b) => b - a)
      if (years.length < 2) {
        this.$notify.error({
          title: '错误',
          message: '至少选择两个年份',
          position: 'bottom-right'
        })
        return false
      }
    },
    handleNodeClick (data) {
      this.currentArea = data.name
      if (data.hasOwnProperty('children')) {
        this.queryData.type = 'area'

        let siteIds = data.children.map(item => {
          let ids = ''
          if (item.hasOwnProperty('children')) {
            ids = ids.concat(item.children.map(({id}) => id).join(','))
          } else {
            ids = ids.concat(item.id)
          }
          return ids
        })
        this.queryData.ids = siteIds.join(',').split(',')
      } else {
        this.queryData.type = 'site'
        this.queryData.ids = [data.id]
      }

      this.getData()
    },
    showErrorData () {
      let {queryData} = this
      this.daysChart = {
        // title: `${currentArea}-AQI优良天数`,
        xAxisData: [],
        series: [{
          name: '优良天数',
          type: 'bar',
          stack: 'total',
          label: {
            show: true,
            position: 'inside'
          },
          data: []
        }, {
          name: '超标天数',
          type: 'bar',
          stack: 'total',
          label: {
            show: true,
            position: 'inside'
          },
          data: []
        }]
      }
      this.rateChart = {
        series: [{
          name: '空气质量天数占比',
          type: 'pie',
          radius: '60%',
          data: [],
          selectedMode: 'single',
          selectedOffset: 30
        }]
      }
      this.AQIDaysChart = {
        dataTime: [],
        xAxisData: ['优', '良', '轻度污染', '中度污染', '重度污染', '严重污染'],
        series: queryData.years.map(item => {
          return {
            name: item,
            type: 'bar',
            data: []
          }
        })
      }
      this.AQIExcellentAvgChartData.seriesData = []
      this.tableData = []
      this.dataDate = queryData.years.map(item => String(item))

      this.$nextTick(() => {
        this.$refs['rate-chart'].render()
        this.$refs['days-chart'].render()
        this.$refs['data-renders'].render()
        this.$refs['aqi-days-chart'].render()
      })
    },
    getData () {
      this.changeLoadStatus(true)
      let {queryData} = this
      if (queryData.ids.length === 0) {
        this.setSiteIds()
        this.changeLoadStatus(false)
        return false
      }
      let routine = {
        'NO2': 0,
        'O3': 0,
        'PM2.5': 0,
        'PM10': 0,
        'SO2': 0,
        'CO': 0
      }
      let classification = [{
        'days': 0,
        'level': 1
      }, {
        'days': 0,
        'level': 2
      }, {
        'days': 0,
        'level': 3
      }, {
        'days': 0,
        'level': 4
      }, {
        'days': 0,
        'level': 5
      }, {
        'days': 0,
        'level': 6
      }]

      if (queryData.years.length < 2) {
        this.$notify.error({
          title: '错误',
          message: '至少选择两个年份',
          position: 'bottom-right'
        })

        this.showErrorData()
        this.changeLoadStatus(false)
        return false
      }

      setTimeout(() => {
        this.$api.Aqi.getYOYAnalysis(queryData).then(backData => {
          if (backData.length === 0 || backData.length < 2) {
            this.showErrorData()
            return false
          }

          let arr = backData.map(el => {
            let temp = classification.map(item => {
              const data = el.classification.find(i => item.level === i.level)
              if (data) {
                return data
              }
              return item
            })
            el.classification = temp
            return {...routine, ...el}
          })

          this.dataArray = arr
          this.formatData()
        }).catch(console.error).finally(() => {
          this.changeLoadStatus(false)
        })
      }, 100)
    },
    formatData () {
      let {dataArray, queryData: {years}} = this
      let currentYearData = dataArray.find(el => Number(el.date) === years[0])
      let beforeYearData = dataArray.find(el => Number(el.date) === years[1])
      let AQIExcellentAvgChartData = []
      let AQIExcellentAvgChartDataKey = []

      for (let el in currentYearData) {
        if (el !== 'date' && el !== 'classification' && el !== 'siteId') {
          AQIExcellentAvgChartDataKey.push(el)
          if (currentYearData[el] - beforeYearData[el] === 0) {
            AQIExcellentAvgChartData.push(0)
          } else if (beforeYearData[el] === 0) {
            AQIExcellentAvgChartData.push('')
          } else if (currentYearData[el] - beforeYearData[el] !== 0) {
            AQIExcellentAvgChartData.push(Number(((currentYearData[el] - beforeYearData[el]) / beforeYearData[el] * 100).toFixed(1)))
          }
        }
      }

      let level = {
        1: '优',
        2: '良',
        3: '轻度污染',
        4: '中度污染',
        5: '重度污染',
        6: '严重污染'
      }

      let arr = dataArray.map(item => {
        let classification = item.classification
        let newData = classification.map(temp => {
          temp.levelName = level[temp.level]
          return temp
        })
        item.classification = newData

        return item
      })

      let days = arr.map(item => {
        let excellent = 0
        let excess = 0
        item.classification.forEach(el => {
          if (el.level <= 2) {
            excellent += el.days
          } else {
            excess += el.days
          }
        })
        return {
          date: item.date,
          excellent: excellent,
          excess: excess
        }
      })

      let tempData = arr.map(el => {
        let sameDays = days.find(({date}) => date === el.date)
        let classification = el.classification.map(item => {
          let temp = {
            level: item.level,
            levelName: item.levelName
          }
          temp[el.date + 'days'] = item.days
          temp[el.date + 'excellent'] = sameDays.excellent
          temp[el.date + 'excellentRate'] = (sameDays.excellent / (sameDays.excellent + sameDays.excess) * 100).toFixed(1)
          return temp
        })

        return classification
      })

      let concatData = tempData[0].map(item => {
        let sameData = tempData[1].find(el => el.levelName === item.levelName)

        return {...item, ...sameData}
      })

      let tempRateData = days.find(item => Number(new Date(item.date).format('YYYY')) === years[0])
      this.rateData = [{
        name: '优良率',
        value: (tempRateData.excellent / (tempRateData.excellent + tempRateData.excess) * 100).toFixed(1)
      }, {
        name: '超标率',
        value: (tempRateData.excess / (tempRateData.excellent + tempRateData.excess) * 100).toFixed(1)
      }]

      let daysChart = {
        // title: `${currentArea}-AQI优良天数`,
        xAxisData: arr.map(({date}) => date),
        series: [{
          name: '优良天数',
          type: 'bar',
          stack: 'total',
          label: {
            show: true,
            position: 'inside'
          },
          data: days.map(item => item.excellent)
        }, {
          name: '超标天数',
          type: 'bar',
          stack: 'total',
          label: {
            show: true,
            position: 'inside'
          },
          data: days.map(item => item.excess)
        }]
      }

      let rateChart = {
        // title: `${new Date(this.queryData.month).format('YYYY-MM')}优良率`,
        series: [{
          name: '空气质量天数占比',
          type: 'pie',
          radius: '60%',
          data: this.rateData,
          selectedMode: 'single',
          selectedOffset: 30
        }]
      }

      let AQIDaysChart = {
        dataTime: arr.map(({date}) => date),
        // title: `${currentArea}-AQI等级天数`,
        xAxisData: arr[0].classification.map(el => el.levelName),
        series: Object.values(arr.reduce((map, item) => {
          if (item.date === new Date(years[0]).format('YYYY')) {
            map[item.date] = {
              name: item.date,
              type: 'bar',
              label: {
                show: true,
                position: 'top',
                formatter: (arg) => {
                  let temp = Object.values(arr).find(el => el.date !== arg.seriesName)
                  let sameLevel = temp.classification.find(el => el.levelName === arg.name)
                  if (arg.value !== 0) {
                    return ((arg.value - sameLevel.days) / sameLevel.days * 100).toFixed(1) + '%'
                  } else {
                    return ''
                  }
                }
              },
              data: item.classification.map(el => el.days)
            }
          } else {
            map[item.date] = {
              name: item.date,
              type: 'bar',
              data: item.classification.map(el => el.days)
            }
          }

          return map
        }, {}))
      }
      this.rateChart = Object.freeze(rateChart)
      this.daysChart = Object.freeze(daysChart)
      this.AQIDaysChart = Object.freeze(AQIDaysChart)
      this.AQIExcellentAvgChartData.xAxisData = AQIExcellentAvgChartDataKey
      this.AQIExcellentAvgChartData.seriesData = Object.freeze(AQIExcellentAvgChartData)
      this.tableData = Object.freeze(concatData)
      this.dataDate = arr.map(({date}) => date)

      this.$nextTick(() => {
        this.$refs['rate-chart'].render()
        this.$refs['days-chart'].render()
        this.$refs['data-renders'].render()
        this.$refs['aqi-days-chart'].render()
      })
    },
    objectSpanMethod ({row, column, rowIndex, columnIndex}) {
      if (columnIndex > 2) {
        if (rowIndex === 0) {
          return {
            rowspan: 6,
            colspan: 1
          }
        } else {
          return {
            rowspan: 0,
            colspan: 0
          }
        }
      }
    }
  },
  watcth: {
    filterSites (val) {
      if (val.length > 0) {
        this.setSiteIds()
        this.getData()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .wrapper {
  overflow: hidden;
}
.chart-item-body {
  height: 470px;
  margin: 15px;
  padding: 5px 5px 30px 5px;
  box-shadow: 0 0 10px 1px rgba(10, 38, 110, 0.07);

  h4 {
    margin: 5px;
  }
}
.sidebar-content-wrapper /deep/ .sidebar-content-body {
  overflow-y: auto;
}
.sidebar-content-wrapper /deep/ .el-table--enable-row-hover .el-table__body tr:hover>td {
  background-color: #FFFFFF;
}
</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/04AQI/01YOY-Analysis/index.vue